export default () => ({
  root: {},
  arrowButton: {},
  todayButton: {},
  dis: {
    opacity: 0.3,
  },
});
